export const TOKEN = 'token'
export const NAME = 'name'
export const EMAIL = 'email'
export const GENDER = 'gender'
export const DATEBIRTH = 'datebirth'
export const USER_REGISTER = 'user_register'